import * as React from "react";
import { CircleTableTop, SquareTableTop, WoodenTableTop } from "../../components";

import { ITables } from "../../all-types";

const tableMap: Record<
  string,
  React.ComponentType<ITables>
> = {
  CIRCULAR: CircleTableTop,
  SQUARE: SquareTableTop,
  RECTANGULAR: WoodenTableTop,
};

const Fallback: React.FC = () => <div>Invalid table configuration</div>;

const TableRenderer: React.FC<ITables> = ({
  tableType,
  capacity,
  tableNo,
  tableColor,
  ...rest
}) => {
  const Component = tableMap[tableType] ?? Fallback;
  if (Component === Fallback) return <Fallback />;

  return <Component  tableNo={tableNo} tableType={"CIRCULAR"} capacity={capacity} tableColor={tableColor} {...rest} />;
};

export  {TableRenderer};
